module.exports = __webpack_public_path__ + "assets/img/logo2@2x.6911ce16.png";